import { Breadcrumb, Button, Card, Modal, Select, Tabs } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import AccountService from "../../../../services/accounts.service";
import { amountFormat } from "../../../../services/common.service";
import { ReactComponent as TitleIcon } from "../../../../assests/images/accountBread.svg";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  loanAccountListSelector,
  modeSelector,
} from "../../../../store/selectors/app.selector";
import ModifyAccountNickName from "../setNickname";
import { setLoanAccountList } from "../../../../store/actions/app.action";

export default function LoanDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const [accountDetails, setAccountDetails] = useState({});
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState("ACCOUNT_DETAILS");
  const [selectedAccountNo, setSelectedAccountNo] = useState(
    location.state.accountNo
  );
  const accountList = useSelector(loanAccountListSelector);
  const mode = useSelector(modeSelector);
  const [visible, setVisible] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    if (location.state) {
      console.log(location.state);
      getAccountSummaryByAccNo(location.state);
    }
  }, []);

  const handleAccountNo = (value) => {
    setSelectedAccountNo(value);
    const accountDet = accountList.find((ele) => ele.accountNo === value);
    getAccountSummaryByAccNo(accountDet);
  };

  const handleTabClick = (key) => {
    setActiveKey(key);
    if (key === "DETAILED_STATEMENT") {
      navigate("/accounts/loan/statement", {
        state: accountDetails,
      });
    }
    if (key === "DISBURSEMENT_INQUIRY") {
      navigate("/accounts/loan/disbursement-inquiry", {
        state: accountDetails,
      });
    }
    if (key === "SCHEDULE_INQUIRY") {
      navigate("/accounts/loan/schedule-inquiry", {
        state: accountDetails,
      });
    }
    if (key === "REPAYMENT") {
      navigate("/accounts/loan/repayment", {
        state: accountDetails,
      });
    }
  };

  const getAccountSummaryByAccNo = useCallback(async (details) => {
    try {
      const response = await AccountService.getLoanAccountSummaryByAccNo({
        acctNo: details.accountNo,
        acctType: details.accountType,
        branchId: details?.branchId,
        customerId: details?.customerId,
      });
      if (response.status === 200) {
        setAccountDetails(response.data);
      }
    } catch (error) {}
  }, []);

  return (
    <>
      <Card size="small" className="mb-2 breadcrumb-card">
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              {t("navigation.home", {
                defaultValue: "Home",
              })}
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/accounts", { state: "LA" })}>
              {t("navigation.account", {
                defaultValue: "Accounts",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("pages.my_accounts.loans.loan_summary", {
                defaultValue: "Loan Summary",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </Card>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-left align-items-center heading mx-0">
             {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("pages.my_accounts.loans.loan_summary", {
                defaultValue: "Loan Summary",
              })}
            </h3>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 hide-xs d-flex justify-content-end">
            <label style={{ fontSize: "16px", padding: "5px" }}>
              {t("pages.accounts.accounts_common.account_no", {
                defaultValue: "Account Number",
              })}{" "}
              :{" "}
            </label>
            <Select
              placeholder={t("pages.accounts.accounts_common.account_no", {
                defaultValue: "Account Number",
              })}
              bordered={true}
              optionLabelProp={"value"}
              size="large"
              value={selectedAccountNo}
              onChange={(value) => handleAccountNo(value)}
              style={{ width: "37%", textAlign: "justify" }}
            >
              {accountList.map((account, index) => (
                <Select.Option key={index} value={account.accountNo}>
                  <span className="acc-short-name">
                    {account?.acctShortName}
                  </span>
                  <br />
                  <span style={{ fontSize: "12px" }}>{account?.accountNo}</span>
                  <br />
                  <span style={{ fontSize: "12px" }}>
                    {account?.branchName}
                  </span>
                </Select.Option>
              ))}
            </Select>
          </div>
        </div>
      </Card>

      <Card className="account-tab-card mb-1">
        <Tabs
          defaultActiveKey="1"
          type="line"
          onChange={setActiveKey}
          activeKey={activeKey}
          onTabClick={handleTabClick}
        >
          <Tabs.TabPane
            tab={t("pages.my_accounts.loans.loan_and_finance_details", {
              defaultValue: "Loan and Finance Details",
            })}
            key="ACCOUNT_DETAILS"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("buttons.view_stmt_btn", {
              defaultValue: "View Statement",
            })}
            key="DETAILED_STATEMENT"
          ></Tabs.TabPane>
          {/* {["I", "AA"].indexOf(mode) > -1 && (
            <Tabs.TabPane
              tab={t("pages.my_accounts.loans.repayment", {
                defaultValue: "Repayment",
              })}
              key="REPAYMENT"
            ></Tabs.TabPane>
          )}
          <Tabs.TabPane
            tab={t("pages.my_accounts.loans.disbursement_inquiry", {
              defaultValue: "Disbursement Inquiry",
            })}
            key="DISBURSEMENT_INQUIRY"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("pages.my_accounts.loans.schedule_inquiry", {
              defaultValue: "Schedule Inquiry",
            })}
            key="SCHEDULE_INQUIRY"
          ></Tabs.TabPane> */}
        </Tabs>
      </Card>

      <Card className="application-card">
        <div className="">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 account-details">
              <label>
                {t("pages.gepeg.customer_name", {
                  defaultValue: "Customer Name",
                })}
              </label>
              <span>{accountDetails?.accountName || "-"}</span>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 account-details">
              <label>
                {t("pages.accounts.accounts_common.account_no", {
                  defaultValue: "Account Number",
                })}
              </label>
              <span className="d-flex">
                {accountDetails?.accountType} &nbsp;
                {accountDetails?.accountNo || "-"}
              </span>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 account-details">
              <label>
                {t("pages.my_accounts.loans.net_outstanding_balance", {
                  defaultValue: "Net Outstanding Balance",
                })}
              </label>
              <span>
                {amountFormat(
                  accountDetails?.netOutstandingBalance || "0",
                  accountDetails.accountCcy
                )}
              </span>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3" align="right">
              {/* <Button
                type="primary"
                onClick={() => {
                  setVisible(true);
                  setSelectedDetails(accountDetails);
                }}
              >
                {t("pages.my_accounts.loans.add_nickname", {
                  defaultValue: "Add Nickname",
                })}
              </Button> */}
            </div>
          </div>
        </div>
      </Card>

      <div className="account-details">
        <Card className="mt-1 application-card">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
              <span style={{ fontSize: "17px" }} className="mb-4">
                {t("pages.gepeg.account_details", {
                  defaultValue: "Account Details",
                })}
              </span>
              <div className="d-block">
                {" "}
                <div className="mb-3">
                  <label>
                    {" "}
                    {t("common.customer_id", {
                      defaultValue: "Customer ID",
                    })}
                  </label>
                  <span>{accountDetails?.customerId || "-"}</span>
                </div>
                <div className="mb-3">
                  <label>
                    {t("pages.my_accounts.loans.opening_date", {
                      defaultValue: "Opening Date",
                    })}
                  </label>
                  <span>{accountDetails?.acctOpenDt || "-"}</span>
                </div>
                <div className="mb-3">
                  <label>
                    {t("pages.my_accounts.deposits.maturity_date", {
                      defaultValue: "Maturity Date",
                    })}{" "}
                  </label>
                  <span>{accountDetails?.expiryDate || "-"}</span>
                </div>
                <div className="mb-3">
                  <label>
                    {t("common.status", { defaultValue: "Status" })}
                  </label>
                  <span>{accountDetails?.status || "-"}</span>
                </div>
                <div className="mb-3">
                  <label>
                    {t("pages.my_accounts.deposits.interest_rate", {
                      defaultValue: "Interest Rate",
                    })}
                  </label>
                  <span>{accountDetails?.interestRate || "-"}%</span>
                </div>
                <div className="mb-3">
                  <label>
                    {" "}
                    {t("pages.locateUs.branch", {
                      defaultValue: "Branch",
                    })}
                  </label>
                  <span>{accountDetails?.branchName || "-"}</span>
                </div>
              </div>
            </div>
            <div className="col-3 hide-xs">
              <span style={{ fontSize: "17px" }} className="mb-4">
                {t("pages.my_accounts.loans.loan_amounts", {
                  defaultValue: "Loan Amounts",
                })}
              </span>
              <div className="d-block">
                <div className="mb-3">
                  <label>
                    {t("pages.my_accounts.loans.total_amount_disbursed", {
                      defaultValue: "Total Amount Disbursed",
                    })}
                  </label>
                  <span>
                    {" "}
                    {amountFormat(
                      accountDetails?.disbursedAmount || "0",
                      accountDetails.accountCcy
                    )}
                  </span>
                </div>{" "}
                <div className="mb-3">
                  <label>
                    {t("pages.my_accounts.loans.principal_repaid_till_date", {
                      defaultValue: "Principal Re-paid Till Date",
                    })}
                  </label>
                  <span>
                    {" "}
                    {amountFormat(
                      accountDetails?.amountPaid || "0",
                      accountDetails.accountCcy
                    )}
                  </span>
                </div>{" "}
                <div className="mb-3">
                  <label>
                    {t("pages.my_accounts.loans.outstanding_amount", {
                      defaultValue: "Outstanding Amount",
                    })}
                  </label>
                  <span>
                    {" "}
                    {amountFormat(
                      accountDetails?.netOutstandingBalance || "0",
                      accountDetails.accountCcy
                    )}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-3 hide-xs">
              {" "}
              <span style={{ fontSize: "17px" }} className="mb-4">
                {t("pages.my_accounts.loans.repayment", {
                  defaultValue: "Repayment",
                })}
              </span>
              <div className="d-block">
                {" "}
                <div className="mb-3">
                  <label>
                    {t("pages.my_accounts.loans.interest_frequency", {
                      defaultValue: "Interest Frequency",
                    })}
                  </label>
                  <span>{accountDetails?.interestFrequency || "-"}</span>
                </div>{" "}
                <div className="mb-3">
                  <label>
                    {t("pages.my_accounts.loans.late_payment_penalty", {
                      defaultValue: "Late Payment Penalty",
                    })}
                  </label>
                  <span>{accountDetails?.latePaymentPenalty || "0"}%</span>
                </div>{" "}
              </div>
            </div>
            <div className="col-3 hide-xs">
              {" "}
              <span style={{ fontSize: "17px" }} className="mb-4">
                {t("pages.my_accounts.loans.installments", {
                  defaultValue: "Installments",
                })}
              </span>
              <div className="d-block">
                {" "}
                <div className="mb-3">
                  <label>
                    {t("pages.my_accounts.loans.total_installments", {
                      defaultValue: "Total Installments",
                    })}
                  </label>
                  <span>{accountDetails?.totalInstallments || "-"}</span>
                </div>{" "}
                <div className="mb-3">
                  <label>
                    {t("pages.my_accounts.loans.remaining_installment", {
                      defaultValue: "Remaining Installment",
                    })}
                  </label>
                  <span>{accountDetails?.remainingInstallment || "-"}</span>
                </div>{" "}
                <div className="mb-3">
                  <label>
                    {t("pages.my_accounts.deposits.next_instalment_date", {
                      defaultValue: "Next Installment Date",
                    })}
                  </label>
                  <span>{accountDetails?.nextInstallmentDate || "-"}</span>
                </div>{" "}
                <div className="mb-3">
                  <label>
                    {t("pages.my_accounts.loans.next_instalment_amount", {
                      defaultValue: "Next Installment Amount",
                    })}
                  </label>
                  <span>
                    {" "}
                    {amountFormat(
                      accountDetails?.nextInstallmentAmount || "0",
                      accountDetails.accountCcy
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
      <Modal
        title= {t("pages.my_accounts.casa.nickname", {
          defaultValue: "Nick Name",
        })}
        closable={false}
        maskClosable={false}
        open={visible}
        footer={null}
        width={480}
        mask={true}
      >
        <ModifyAccountNickName
          key={new Date().getTime()}
          setVisible={setVisible}
          selectedDetails={selectedDetails}
          setRefresh={() => {
            setVisible(false);
            dispatch(setLoanAccountList([]));
          }}
        />
      </Modal>
    </>
  );
}
